<template>
    <div>
       空间管理
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>
